import { createAsyncThunk } from "@reduxjs/toolkit";
import { PutVouchersSubvouchersBody } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const putVouchersSubvouchers = createAsyncThunk<
  void,
  PutVouchersSubvouchersBody
>("vouchers/putVouchersSubvouchers", async (body, { rejectWithValue }) => {
  try {
    await VouchersAPI.putVouchersSubvouchers(body);
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while updating subvouchers", error.response?.data);
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
